import { SchoolLevelSubjects } from "@common/SchoolLevelSubjects";

export const codeUtil = {
    /**
     * Generates a unique alphanumeric code.
     * @param {number} length - Length of the generated code (default is 8)
     * @returns {string} Random uppercase alphanumeric code
     */
    createCode: (length = 8) => {
        return [...Array(length)]
            .map(() => Math.random().toString(36).charAt(2).toUpperCase())
            .join('');
    },

    /**
	 * // 2025-04-08 giwon - 
			// 데이터흐름, ProjectStore이 참 요란해서 입력부분에서 고치지 않고, 그냥 출력부분에서 하드코딩 매핑
			// 페이지에서 초6 선택하면 grade "1", schoolType NoGR로 들어감 -> 초6으로 리턴
			// 페이지에서 중3 선택하면 grade "2", schoolType NoGR로 들어감 -> 중3으로 리턴
			// 페이지에서 고1~3 선택하면 grade "3", schoolType NoGR로 들어감 -> 고1~3으로 리턴
	 */
    mappedGradeStringAndSchoolString(grade: string): [string, string] {

        let mappedGrade = "";
    	let schoolType = "";

        if (grade === "1") {
            mappedGrade = "6학년";
            schoolType = "초등학교"
        } else if (grade === "2") {
            mappedGrade = "3학년";
            schoolType = "중학교"
        } else if (grade === "3") {
            mappedGrade = "1~3학년";
            schoolType = "고등학교"
        }

        return [mappedGrade, schoolType];
    },
    translatedSubjectName(name: string): string {
        for (const school of SchoolLevelSubjects) {
            for (const group of school.subjectGroups) {
                const found = group.subjects.find(subject => subject.name === name);
                if (found) {
                    return found.text;
                }
            }
        }

        return "";
    }
    
            
};